<template>
  <section class="content">
    <div class="box box-info" >
        <div id="overlay"  v-if="loading">
          <div class="spinner"></div>
          <br/>
            <h4>Loading...</h4>
         </div>
      <form class="form-horizontal" >
        <div class="container-fluid">
           <Button class="btn btn-primary" style="float: right;margin-bottom: 0.5em;" type="button"
            @click="openAddDialog" ><i class="fa fa-plus-circle" aria-hidden="true"></i>
           </Button>
        </div>
        <Dialogs header="Organization"  position="center" :visible.sync="addDisplayBasic" :style="{width: '50vw'}"
         :modal="true" :closable=true >
          <form class="form-horizontal" >
             <div style="margin: 0% -20% 0% 2%;">
               <label for="accountType" class="col-form-label"
                style="color:#3c8dbc;margin: 0% 0% 2% 0%;">Organization info:</label>
             <div class="form-group">
             <label for="name" class="col-sm-3 col-form-label">Name</label>
              <input
                type="text"
                class="col-sm-5 form-control _input"
                id="name"
                v-model.trim="name"
                placeholder=""
              />
               <label for="shortName" class="col-sm-3 col-form-label">Short Name</label>
              <input
                type="text"
                v-model.trim="shortName"
                class="col-sm-5 form-control _input"
                id="shortName"
              />

          </div>
            <div class="form-group">
              <label for="contactPerson" class="col-sm-3 col-form-label">Contact Person</label>

              <input
                type="text"
                v-model.trim="contactPerson"
                class="col-sm-5 form-control _input"
                id="contactPerson"
                placeholder=""
              />
                <label for="contactNum" class="col-sm-3 col-form-label">Contact Number</label>

              <input
                type="text"
                @keypress="isNumber($event)"
                v-model="contactNumber"
                class="col-sm-5 form-control _input"
                id="contactNum"
                placeholder="98XXXXXXXX"
              />


          </div>
          <div class="form-group">
             <label for="tel" class="col-sm-3 col-form-label">Tel-phone</label>
            <input
                type="text"
                @keypress="isNumber($event)"
                v-model.trim="telcontact"
                class="col-sm-5 form-control _input"
                id="tel"
              />
                 <label for="email" class="col-sm-3 col-form-label">Email</label>
              <input
                type="text"
                v-model.trim="email"
                class="col-sm-5 form-control _input"
                id="email"
                placeholder=""
              />
        </div>

         <div class="form-group">

         <label for="address" class="col-sm-3 col-form-label">Address</label>
         <input
                type="text"
                v-model.trim="address"
                class="col-sm-5 form-control _input"
                id="address"
                placeholder=""
              />
              <label class="col-sm-3 col-form-label">Organisaction Type</label>
            <select class="custom-select form-control col-sm-5 dropDown" v-model="taxType">
            <option selected disabled value="">Select Type</option>
            <option  v-for="(vat,ind) in organisaction_type" :key="ind">{{vat.taxType}}</option>
            </select>
         </div>

          <div class="form-group">
                <label for="panNo"
              class="col-sm-3 col-form-label">Pan/Vat No</label>
              <input
                type="text"
                @keypress="isNumber($event)"
                v-model.number="panNo"
                class="col-sm-5 form-control _input"
                id="panNo"
                placeholder=""
              />
           <label class="col-sm-3 col-form-label">Date Type</label>
            <select class="custom-select form-control col-sm-5 dropDown" v-model="isEnglishDate">
              <option selected disabled value="">Select Date</option>
              <option  v-for="(date,ind) in date_list" :key="ind">{{date.isEnglishDate}}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="address" class="col-sm-3 col-form-label">Website</label>
            <input
                type="text"
                v-model.trim="website"
                class="col-sm-5 form-control _input"
                id="address"
                placeholder=""
              />
          </div>

          <label for="accountType" v-if="!this.editing"
           class="col-form-label" style="color:#3c8dbc;margin: 0% 0% 2% 0%;">User info:</label>
              <div class="form-group" v-if="!this.editing">
             <label for="panNo"
              class="col-sm-3 col-form-label">Name</label>

              <input
                type="text"
                v-model="nameOfuser"
                class="col-sm-5 form-control _input"
                id="panNo"
                placeholder=""
              />
                <label for="panNo"
              class="col-sm-3 col-form-label">Username</label>

              <input
                type="text"
                v-model="username"
                class="col-sm-5 form-control _input"
                id="panNo"
                placeholder=""
              />
          </div>
          <div class="form-group" v-if="!this.editing">
             <label for="panNo"
              class="col-sm-3 col-form-label">Password</label>

              <input
                type="text" disabled=true
                v-model="password"
                class="col-sm-5 form-control _input"
                id="panNo"
              />
          </div>
            <div class="form-group col-md-6">
              <label for="imageUpload" style="margin-left: -5px;" class="col-sm-3 col-form-label">Image </label>
              <div class="col-md-2">
                <button @click.prevent="showItemUpload" style="float: left;margin-left: 5.5em;" class="btn btn-primary">Upload Image</button>
              </div>
              <!-- Image Upload Dialog -->
              <Dialogs header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}" :closable="false">
                <input type="file" id="files" style="margin-bottom: 2em;" class="hidden" @change="onFileSelect"/>
                <label for="files" style="margin-left: 2em;">Choose Image</label>
                <Carousel :value="url" :numVisible="2" :numScroll="2">
                    <template #item="slotProps">
                        <div class="product-item">
                            <div class="product-item-content">
                                <div class="p-mb-3">
                                    <img  :src="slotProps.data" style="height:250px;width:250px" class="product-image" />
                                </div>
                                <div>
                                    <div class="car-buttons p-mt-5">
                                        <Button class="btn btn-danger" @click.prevent="removeImage(slotProps.data,slotProps)"><i class="fa fa-trash" aria-hidden="true"></i></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </Carousel>
                <template #footer>
                  <Button class="btn btn-info" type="cancel" @click.prevent="closeImageUpload">Back</Button>
                  <Button class="btn btn-danger" type="cancel" @click.prevent="cancelImageUpload">Cancel</Button>
                </template>
              </Dialogs>
              <!-- Image Upload Dialog -->
              <div class="col-md-2" v-if="this.imageList.length > 0">
                <button  @click.prevent="viewImage" style="float: left;margin-left: 12em;" class="class-sm-1 btn btn-primary">View Image</button>
              </div>
              <Dialogs header="View Image " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
                <div>
                  <div class="card">
                  <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                      <template #item="slotProps">
                          <div class="product-item">
                              <div class="product-item-content">
                                  <div class="p-mb-3">
                                      <img  :src="slotProps.data.name" style="height:250px;width:250px" class="product-image" />
                                  </div>
                                  <div>
                                      <div class="car-buttons p-mt-5">
                                          <Button class="btn btn-danger" @click.prevent="removeImage(slotProps.data,slotProps)"><i class="fa fa-trash" aria-hidden="true"></i></Button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </template>
                  </Carousel>
                </div>
                </div>
              </Dialogs>
            </div>
            <div class="box-footer" style="margin-top: 2em;float: left;">
             <button type="submit" class="btn btn-primary pull-left"
              @click.prevent="addOrganisation"
              style="margin-right:5px;">{{this.editing?'Update':'Add'}}</button>
              <button type="submit" @click.prevent="addCancel" class="btn btn-danger">Cancel</button>
            </div>
            </div>

          </form>
        </Dialogs>
        </form>
      <DataTable
      :value="organizationLists"
      :paginator="true"
      :rows="8"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.n" field="id" />
      <Column header="Name" field="name" filterField="name" filterMatchMode="contains" />
      <Column
        header="Short Name"
        field="shortName"
        filterField="shortName"
        filterMatchMode="contains"
      />

    <Column header="Contact Person" field="contactPerson"
     filterField="contactPerson" filterMatchMode="contains" />

      <Column header="Address" field="address" filterField="address"
       filterMatchMode="contains" />

       <Column header="Contact Number" field="contactNumber"
        filterField="contactNumber" filterMatchMode="contains" />

     <Column header="Pan/Vat No" field="panNumber"
        filterField="panNumber" filterMatchMode="contains" />

      <Column header="Action">
       <template #body="slotProps">
         &nbsp;
          <button  class="btn btn-success"  @click="editOrganization(slotProps.data)">
            <i class="fa fa-edit" />
          </button>&nbsp;&nbsp;
           <button class="btn btn-danger"   @click="openDialog(slotProps.data.id)" >
              <i class="fa fa-trash" aria-hidden="true"></i>
           </button>
        </template>
      </Column>
    </DataTable>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteOrganization"/>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import InputMask from 'primevue/inputmask'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialogs from 'primevue/dialog'
import Dialog from '../../layout/dialog'
import RadioButton from 'primevue/radiobutton'
import Carousel from 'primevue/carousel'

export default {
  name: 'customer',
  data() {
    return {
      name: '',
      contactNumber: '',
      username: '',
      nameOfuser: '',
      address: '',
      shortName: '',
      contactPerson: '',
      telcontact: '',
      secondaryContact: '',
      password: '123456',
      email: '',
      panNo: '',
      taxType: '',
      website: '',
      isEnglishDate: '',
      addDisplayBasic: false,
      editing: false,
      displayBasic: false,
      dialogShow: false,
      openImageViewer: false,
      images: [],
      url: [],
      date_list: [
        {'isEnglishDate': 'Nepali'},
        {'isEnglishDate': 'English'}
      ],
      organisaction_type: [
        {'taxType': 'Vat'},
        {'taxType': 'Pan'}
      ],
      id: '',
      loading: false,
      deletedImage: [],
      imageList: [],
      orgId: '',
      showItemUploadDialog: false
    }
  },
  computed: {
    organizationLists() {
      return this.$store.state.admin.organizationLists
    }
  },
  mounted() {
    this.organizationList()
  },
  methods: {
    async addOrganisation() {
      if (this.name === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter name!', life: 10000})
        return
      }
      let user = {
        username: this.username,
        name: this.nameOfuser,
        password: this.password
      }
      if (this.isEnglishDate === 'English') {
        this.isEnglishDate = true
      } else {
        this.isEnglishDate = false
      }
      let organisation = {
        name: this.name,
        shortName: this.shortName,
        contactNumber: this.contactNumber,
        telPhone: this.telcontact,
        address: this.address,
        email: this.email,
        contactPerson: this.contactPerson,
        taxType: this.taxType,
        id: this.id,
        panNumber: this.panNo,
        englishDateTransaction: this.isEnglishDate,
        userDTO: user,
        webSite: this.website,
        deletedImage: this.deletedImage
      }
      const formData = new FormData()
      formData.append('organisation', JSON.stringify(organisation))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      let resp = ''
      if (!this.editing) {
        this.loading = !this.loading
        resp = await this.$store.dispatch('createOrganization', formData)
        this.loading = false
      } else {
        this.loading = !this.loading
        resp = await this.$store.dispatch('updateOrganization', formData)
        this.loading = false
      }
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.reset()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    editOrganization(data) {
      this.addDialog = !this.addDialog
      this.id = data.id
      this.editing = true
      this.name = data.name
      this.shortName = data.shortName
      this.address = data.address
      this.telcontact = data.telPhone
      this.contactNumber = data.contactNumber
      this.email = data.email
      this.contactPerson = data.contactPerson
      this.panNo = data.panNumber
      if (data.englishDateTransaction === true) {
        this.isEnglishDate = 'English'
      } else {
        this.isEnglishDate = 'Nepali'
      }
      this.taxType = data.taxType
      this.website = data.webSite
      if (data.imageList.length > 0) {
        this.imageList = data.imageList
      }
      this.openAddDialog()
    },
    async deleteOrganization(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot not be empty!', life: 10000})
        return
      }
      let deleteRe = {
        id: this.orgId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteOrganization', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
      }
    },
    async organizationList() {
      await this.$store.dispatch('loadOrganization')
    },
    addCancel() {
      this.error = false
      this.reset()
      this.closeAddDialog()
    },
    reset() {
      this.editing = false
      this.name = ''
      this.email = ''
      this.address = ''
      this.contactNumber = ''
      this.contactPerson = ''
      this.shortName = ''
      this.telcontact = ''
      this.closeAddDialog()
      this.secondaryContact = ''
      this.contactPerson = ''
      this.panNo = ''
      this.taxType = ''
      this.username = ''
      this.nameOfuser = ''
      this.website = ''
      this.isEnglishDate = ''
      this.images = []
      this.url = []
    },
    openAddDialog() {
      this.addDisplayBasic = true
    },
    closeAddDialog() {
      this.addDisplayBasic = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    openDialog(id) {
      this.dialogShow = true
      this.orgId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      // this.show = false
      this.dialogShow = false
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    closeImageUpload() {
      this.showItemUploadDialog = false
    },
    cancelImageUpload() {
      this.showItemUploadDialog = false
      this.url = []
      this.images = []
    }
  },
  components: {
    Dropdown,
    InputMask,
    Column,
    DataTable,
    Dialog,
    Dialogs,
    RadioButton,
    Carousel
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// adminOrganization.vue?2f401a96